<template>
  <div>
    <Breadcrumbs class="ml-n6" :items="itemsBreadcrumbs"/>
    <Heading v-bind="headerProps" headerColor="gray scale200" class="pb-0 text-h3"/>
    <AlertNewPanel/>
    <LoadingArea style="position: relative z-index: 2" :display-content="!loading">
      <template #loading>
        <Row>
          <Col v-for="i in 8" :key="i" cols="12">
            <SkeletonLoader type="list-item-three-line" elevation="1"/>
          </Col>
        </Row>
      </template>
      <template v-if="hasSites">
        <div class="gray scale100 py-5 rounded-md">
          <TextField :label="t$.filter.label" :placeholder="t$.filter.placeholder" :ga="inputsEvent('buscarSite')" v-model="search"
                     prepend-inner-icon="$objects-magnify-outline" required/>
        </div>
        <Row tag="ul" v-if="filterSitesByDomain">
          <Col cols="12" tag="li" v-for="(site,index) in filterSitesByDomain" :key="site.id" class="translate-top-animation"
               :style="`animation-delay: ${20 * index}ms`">
            <SiteCard :site="site" @modalValue="modalValue" @closeSsl="closeSsl"/>
          </Col>
        </Row>
        <Row tag="ul" v-else>
          <Col cols="12" class="translate-top-animation" :style="`animation-delay: ${20 * index}ms`">
            <p>Nenhum site encontrado. Tente novamente.</p>
          </Col>
        </Row>
      </template>
      <template v-else>
        <PageResult class="mt-16" :error="error" :text-results="t$.result" :values="emptyStateValues"
                    :action-route="createLink" :error-status-code="statusCode"/>
      </template>
    </LoadingArea>
      <ModalBackup v-if="displayBackup" @closeCancel="closeCancel"/>
      <ModalCdn
        :idSite="id"
        :filteredData="dataSites"
        v-if="displayCdn"
        @closeCancel="closeCancel"
        @closeModal="closeModal"
      />
      <ModalDeleteSite v-if="displayDelete" @closeCancel="closeCancel" @closeModal="closeModal" :idSite="id" :filteredData="dataSites"/>
      <ModalSiteLimit :idSite="id" :filteredData="dataSites" v-if="displaySiteLimit" @closeCancel="closeCancel"/>
  </div>
</template>

<style>
  @media (max-width: 820px) {
    .ds-breadcrumbs {
      padding-left: 16px;
    }
  }
</style>

<script>
import {
  Col,
  Heading,
  LoadingArea,
  Row,
  SkeletonLoader,
  TextField,
  useAPI,
  useLocale,
  useStorage,
  Breadcrumbs,
  useGEvents
} from '@locaweb/design-system-vue'
import { onMounted, computed, onBeforeMount, ref } from 'vue'
import { findAll, checkMigration } from '@/views/site/api/site.api'
import { findConsumption } from '@/views/plan/api/plan.api'
import PageResult from '@/components/PageResult'
import { authStore } from '@/store/auth'
import { SitesRoutesPath } from '@/views/site/router'
import SiteCard from '@/views/site/list/components/SiteCard'
import { useFindPlan } from '@/views/site/functions/useFindPlan'
import ModalBackup from './components/modal/ModalBackup'
import ModalCdn from './components/modal/ModalCdn'
import ModalDeleteSite from './components/modal/ModaDeleteSite'
import AlertNewPanel from '@/components/AlertNewPanel'
import ModalSiteLimit from './components/modal/ModalSiteLimit'
import { gEventsTrigger } from '@/functions/gEventsTrigger'

export default {
  name: 'SiteList',
  props: {
    id: String
  },
  components: {
    AlertNewPanel,
    Heading,
    Row,
    Col,
    LoadingArea,
    PageResult,
    TextField,
    SiteCard,
    SkeletonLoader,
    ModalBackup,
    ModalCdn,
    ModalDeleteSite,
    Breadcrumbs,
    ModalSiteLimit
  },
  data () {
    return {
      displayBackup: false,
      displayCdn: false,
      displayDelete: false,
      modalProps: {},
      sslEnable: false,
      dataSites: {},
      search: ''
    }
  },
  methods: {
    inputsEvent (inputName) {
      return gEventsTrigger(this.gEvents, inputName)
    },
    allSites () {
      this.findSites(this.id)
    },
    async findSites (id) {
      try {
        const data = await findAll(id)
        this.dataSites = data.data

        localStorage.setItem('dataSites', JSON.stringify(this.dataSites))
      } catch (error) {
        console.error(error)
      }
    },
    modalValue () {
      if (this.$route.name === 'backup') {
        this.displayBackup = true
      }
      if (this.$route.name === 'cdn') {
        this.displayCdn = true
      }
      if (this.$route.name === 'delete') {
        this.displayDelete = true
      }
    },
    closeCancel () {
      if (this.$route.name === 'backup') {
        this.displayBackup = false
      }
      if (this.$route.name === 'cdn') {
        this.displayCdn = false
      }
      if (this.$route.name === 'delete') {
        this.displayDelete = false
      }
      if (this.$route.name === 'siteLimit') {
        this.displaySiteLimit = false
      }
      const idSite = this.dataSites[0].plan_id
      this.$router.push(SitesRoutesPath.LISTAR.path.replace(':id', idSite))
    },
    closeModal () {
      if (this.$route.name === 'backup') {
        this.displayBackup = false
      }
      if (this.$route.name === 'cdn') {
        this.displayCdn = false
      }
      if (this.$route.name === 'delete') {
        this.displayDelete = false
      }
      if (this.$route.name === 'siteLimit') {
        this.displaySiteLimit = false
      }
      const idSite = this.dataSites[0].plan_id
      this.$router.push(SitesRoutesPath.LISTAR.path.replace(':id', idSite))
      this.loading = true
      setTimeout(() => {
        this.findSites(idSite)
        this.loading = false
      }, 5000)
    },
    closeSsl () {
      const idSite = this.dataSites[0].plan_id
      this.$router.push(SitesRoutesPath.LISTAR.path.replace(':id', idSite))
      this.loading = true
      setTimeout(() => {
        this.findSites(idSite)
        this.loading = false
      }, 3000)
    }
  },
  mounted () {
    this.allSites()
  },
  computed: {
    itemsBreadcrumbs () {
      const selectedBreadcrumbs = [
        { text: 'Listagem de Planos', to: '/', disabled: false, exact: true },
        { text: this.headerProps.title, disabled: true, exact: true }
      ]
      localStorage.setItem('headerProps', JSON.stringify(this.headerProps.title))
      return selectedBreadcrumbs
    },
    filterSitesByDomain () {
      const store = Array.isArray(this.dataSites) ? this.dataSites : []
      const search = this.search?.toLowerCase() || ''
      const filteredSites = store.filter(site => {
        const domain = site.domain?.toLowerCase() || ''
        return domain.includes(search)
      })
      if (filteredSites.length === 0) {
        return false
      }
      return filteredSites
    },
    gEvents () {
      return this.$gEvents('listaDeSites')
    }
  },
  setup (props) {
    const gEvents = useGEvents('criarNovoSite')
    const displaySiteLimit = ref(false)

    useFindPlan(props.id)
    const t$ = useLocale('sites.list')
    const {
      data,
      execute,
      loading,
      error,
      statusCode
    } = useAPI({
      request: findAll,
      param: props.id
    })

    const consumption = useAPI({
      request: findConsumption,
      param: props.id
    })
    const filter = ref('')

    onBeforeMount(_ => {
      execute()
      consumption.execute()
    })

    const emptyStateValues = { name: authStore().user.name }
    const hasSites = computed(_ => data.value && !data.value.isEmpty())
    const [renamePaths] = useStorage({
      key: 'renamePaths',
      initialValue: {},
      type: 'sessionStorage'
    })

    const consumed = computed(_ => (
      consumption.data.value.consumed
    ))
    console.log('consumed', consumed)

    const migrationInProgress = ref(false)

    const checkMigrationStatus = async () => {
      try {
        migrationInProgress.value = await checkMigration(props.id)
      } catch (error) {
        console.error('Error checking migration:', error)
      }
    }

    onMounted(checkMigrationStatus)

    const headerProps = computed(_ => (
      {
        title: renamePaths.value ? renamePaths.value[`/${props.id}`] : t$.title,
        header: hasSites.value,
        divider: false,
        large: hasSites.value,
        ...!consumption.loading.value && !consumption.error.value && { subtitle: t$.usage.replaceValues(consumption.data.value) },
        ...hasSites.value && !migrationInProgress.value && {
          ...consumption.data.value.consumed < consumption.data.value.limit && {
            actions: {
              label: t$.headerAction,
              ga: gEvents.criarNovoSite,
              to: SitesRoutesPath.ADICIONAR.path.replace(':id', props.id)
            }
          },
          ...consumption.data.value.consumed === consumption.data.value.limit && {
            actions: {
              label: t$.headerAction,
              to: SitesRoutesPath.siteLimit.path.replace(':id', props.id),
              ga: gEvents.criarNovoSite,
              click: () => { displaySiteLimit.value = true }
            }
          }
        }
      }
    ))

    const createLink = computed(_ => error.value && statusCode.value === 404 ? '/' : SitesRoutesPath.ADICIONAR.path.replace(':id', props.id))

    return {
      t$,
      loading,
      error,
      headerProps,
      consumption,
      hasSites,
      emptyStateValues,
      createLink,
      statusCode,
      filter,
      displaySiteLimit
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 0 !important
}
</style>
